import React, { useState, useContext, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";
import "./assets/css/demo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import MyContext from "MyContext";
import AdminLayout from "layouts/Admin.js";
import Login from "./components/login.js";
import InvoiceGenerator from "views/InvoiceGenerator";
import SubscriptionInvoiceGenerator from "views/SubscriptionInvoiceGenerator";
import TestInvoiceGenerator from "views/TestInvoiceGenerator";
import PrivateRoute from "components/privates/PrivateRoute"; 

function App() {
  const { endPointUrl, Token } = useContext(MyContext);
 const [user, setuser] = useState(() => {
  const storedUser = sessionStorage.getItem("data");
  return storedUser ? JSON.parse(storedUser) : {};
});

const updateUser = (userData) => {
  setuser(userData);
  sessionStorage.setItem("data", JSON.stringify({ ...userData, Password: "" }));
};

useEffect(() => {
  // Optional: Refresh the user from storage if needed
  const storedUser = sessionStorage.getItem("data");
  if (storedUser) {
    setuser(JSON.parse(storedUser));
  }
}, []);

  return (
    <MyContext.Provider value={{ Token, user, updateUser, endPointUrl }}>
      <Switch>
        {/* Public route for login */}
        <Route path="/" exact render={(props) => <Login updateUser={updateUser} />} />

        {/* Protected routes */}
        <PrivateRoute path="/admin" component={AdminLayout} />
        <PrivateRoute path="/Invoice-Generator" component={InvoiceGenerator} />
        <PrivateRoute path="/Subscription-Invoice-Generator" component={SubscriptionInvoiceGenerator} />
        <PrivateRoute path="/Test-Invoice-Generator" component={TestInvoiceGenerator} />

        {/* Default fallback */}
        <Redirect to="/" />
      </Switch>
    </MyContext.Provider>
  );
}

export default App;
